      <template>
        <div>        
          <transition>
            <div v-if="show">
              <transition>
                <div>
                  <div style="position: absolute;" class="tutorial-block" v-drag>
                    <div class="d-flex align-items-center justify-content-center tutorial-title-block">
                      <span class="tutorial-icon">
                        <b-icon-book-half></b-icon-book-half>
                        {{ $t("TUTORIAL") }}
                      </span>
                      <span class="btn" @click="viewTutorial">
                        <b-icon-x-circle class="float-right"></b-icon-x-circle>
                      </span>
                    </div>
                    <div class="tutorial-detail-block text-white pt-2">
                      <p style="font-size: 14px; padding-left: 6px;">
                        NFT Generator の操作方法です。<br>
                        当タブは移動可能なので自由に動かしていただきながら利用できます。
                      </p>
                      <p style="font-size: 10px; padding-left: 6px;">
                        ※NFT Generator について動画での解説も用意しております。<br>
                        <a href="https://www.youtube.com/channel/UC0oQT-PejASunw6Qy9YCAjg">https://www.youtube.com/channel/UC0oQT-PejASunw6Qy9YCAjg</a>
                      </p>
                      <div>
                        <div class="scrollItem">
                          <VuePerfectScrollbar>
                            <div class="container">
                              <img src="@/assets/images/01.png" v-on:click="showModal" class="mt-2" width="250px">

                              <!-- ② モーダル -->
                              <div v-if="modalVisible" v-on:click="closeModal" class="l-modal">
                                <div v-on:click="cancelEvent" class="p-modal">
                                  <img src="@/assets/images/01.png" class="mt-2" width="100%">  
                                  <!-- モーダルを閉じるボタン -->
                                  <div v-on:click="closeModal" class="p-modal__btn--close">×</div>
                                </div> 
                              </div> 
                              <!-- ③ モーダル表示時の背景色（薄い黒） -->
                              <div v-if="modalBgVisible" class="l-modal__bg"></div>

                              <div style="font-size: 14px;" class="my-2 font-weight-bold">① レイヤーの追加</div>
                              <div style="font-size: 12px;">
                                まず、NFT の要素となる各レイヤー（目、鼻、口、髪型、服装など）を設定していきます。
                                左上部の[NFT 要素の管理]タブを選択した状態で、右側のレイヤーを設定項目内の[レイヤーを追加]の＋マークからレイヤーを追加できます。<br>
                                <br>
                                追加後、名称の変更ができるのでわかるような名前に変更します。
                              </div>
                              <img src="@/assets/images/02.png" v-on:click="showModal_2" class="mt-2" width="250px">    

                               <div v-if="modalVisible_2" v-on:click="closeModal" 　class="l-modal">
                                <div v-on:click="cancelEvent" class="p-modal">
                                  <img src="@/assets/images/02.png" class="mt-2" width="100%">  
                                  <!-- モーダルを閉じるボタン -->
                                  <div v-on:click="closeModal" class="p-modal__btn--close">×</div>
                                </div> 
                              </div> 
                              <div v-if="modalBgVisible" class="l-modal__bg"></div>

                              <div style="font-size: 14px;" class="my-2 font-weight-bold">②各レイヤーの要素を設定</div>
                              <div style="font-size: 12px;">
                                次に、 ①にて追加した各レイヤーに使用したい画像をそれぞれ設定していきます。設定するレイヤーが選択された状態で画像をアップロードします。<br>
                                <br>
                                [NFT 要素の管理]枠内にある[ファイルをアップロードする]から画像を選択もしくは、ドラッグ＆ドロップにて画像をアップロードします。アップロード後、各要素の名称も変更ができます。<br>
                                ※対応ファイルは現状『png』のみです。また、各レイヤー10 枚までのアップロードを推奨しております。
                              </div>
                              <img src="@/assets/images/03.png" v-on:click="showModal_3" class="mt-2" width="250px">

                               <div v-if="modalVisible_3" v-on:click="closeModal" 　class="l-modal">
                                <div v-on:click="cancelEvent" class="p-modal">
                                  <img src="@/assets/images/03.png" class="mt-2" width="100%">  
                                  <!-- モーダルを閉じるボタン -->
                                  <div v-on:click="closeModal" class="p-modal__btn--close">×</div>
                                </div> 
                              </div> 
                              <div v-if="modalBgVisible" class="l-modal__bg"></div>

                              <div style="font-size: 14px;" class="my-2 font-weight-bold">③各要素の出現率を設定</div>
                              <div style="font-size: 12px;">
                                各レイヤーとレイヤー内の各要素に出現率を設定できます。出現率を変更することで画像生成時のレアリティを任意に変えることができます。<br>
                                変更したいレイヤーを選択し、[NFT 要素の管理]枠内から要素を選択した状態で、選択した「レイヤー」と「NFT 要素」の出現率を0～100％の範囲で変更できます。<br>
                                <br>
                                ※出現率ではなく任意で生成パターンを指定できる機能につきましては製品版リリース時
                                (3 月1 日)に実装予定です。
                              </div>
                              <img src="@/assets/images/04.png" v-on:click="showModal_4" class="mt-2" width="250px">

                               <div v-if="modalVisible_4" v-on:click="closeModal" 　class="l-modal">
                                <div v-on:click="cancelEvent" class="p-modal">
                                  <img src="@/assets/images/04.png" class="mt-2" width="100%">  
                                  <!-- モーダルを閉じるボタン -->
                                  <div v-on:click="closeModal" class="p-modal__btn--close">×</div>
                                </div> 
                              </div> 
                              <div v-if="modalBgVisible" class="l-modal__bg"></div>

                              <div style="font-size: 14px;" class="my-2 font-weight-bold">④生成する画像の枚数と名称を設定</div>
                              <div style="font-size: 12px;">
                                生成したい画像の枚数と画像の名前を編集できます。<br>
                                [プレビュー]タブを選択し、作成したい枚数と設定した名称を変更していきます。<br>
                                <br>
                                例）生成画像数：100 枚 名前：sample<br>
                                sample001.png,sample002.png,sample001.png ～ sample100.pngが生成されます。
                              </div>
                              <img src="@/assets/images/05.png" v-on:click="showModal_5" class="mt-2" width="250px">

                               <div v-if="modalVisible_5" v-on:click="closeModal"　class="l-modal">
                                <div v-on:click="cancelEvent" class="p-modal">
                                  <img src="@/assets/images/05.png" class="mt-2" width="100%">  
                                  <!-- モーダルを閉じるボタン -->
                                  <div v-on:click="closeModal" class="p-modal__btn--close">×</div>
                                </div> 
                              </div> 
                              <div v-if="modalBgVisible" class="l-modal__bg"></div>

                              <div style="font-size: 14px;" class="my-2 font-weight-bold">⑤生成された画像をダウンロードする</div>
                              <div style="font-size: 12px;">
                                レイヤーと要素によって生成された画像をダウンロードします。<br>
                                <br>
                                [プレビュー]タブ内にて[プレビューを確認]をクリックすると、設定した枚数分の生成画像が表示されます。<br>
                                保存したい場合は、[ダウンロードする]をクリックします。<br>
                                ダウンロードする情報には、生成した画像のメタ情報を示すCSV ファイルがございます。<br>
                                OpenSea 等、マーケットプレイスにミントする際などにご利用ください。<br>
                                β 版は無料でダウンロード可能です。製品版はダウンロードする枚数に応じて金額が異なります。
                              </div>
                              <img src="@/assets/images/06.png" class="mt-2" width="250px">
                              <div style="font-size: 14px;" class="my-2 font-weight-bold">※OpenSea に自動アップロード機能も実装予定</div>
                              <div style="font-size: 12px;">
                                Metamask と連携し、署名を行い本製品にて独自コントラクトの自動作成を行い、自動でミントができます。ミント完了後は Metamask にてOpenSea にログインを行うと生成したNFT が確認できます。<br>
                                本機能は製品版リリース時(3 月1 日)に実装予定です。
                              </div>
                            </div>
                          </VuePerfectScrollbar>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </transition>

          <b-button type="button" class="btn" @click="viewTutorial">
            <b-icon-book-half></b-icon-book-half>
            {{ $t("VIEW_TUTORIAL") }}
          </b-button>

       </div>
      </template>


<script>
import drag from '@branu-jp/v-drag'
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    name: "Tutorial",
    components: {
        VuePerfectScrollbar,
    },
    data(){
        return {
            show: false,
            settings: {
                maxScrollbarLength: 60
            },
            modalVisible: false, // モーダル
            modalVisible_2: false,
            modalVisible_3: false,
            modalVisible_4: false,
            modalVisible_5: false,
            modalBgVisible: false //モーダル背景色（薄黒）
        };
    },
    methods:{
        viewTutorial: function () {
            this.show = !this.show
        },
        showModal: function(){
            this.modalVisible = true
            this.modalBgVisible = true
        },
        showModal_2: function(){
            this.modalVisible_2 = true
            this.modalBgVisible = true
        },
        showModal_3: function(){
            this.modalVisible_3 = true
            this.modalBgVisible = true
        },
        showModal_4: function(){
            this.modalVisible_4 = true
            this.modalBgVisible = true
        },
        showModal_5: function(){
            this.modalVisible_5 = true
            this.modalBgVisible = true
        },
        closeModal: function(){
            this.modalVisible = false
            this.modalVisible_2 = false
            this.modalVisible_3 = false
            this.modalVisible_4 = false
            this.modalVisible_5 = false
            this.modalBgVisible = false
        },
        cancelEvent: function(){ 
            event.stopPropagation() 
         },
    },
    directives: {
        drag
    },
}
</script>


<style>
.tutorial-block{
  width: 300px;
  border: 1px solid #707070;
  border-radius: 6px;
  z-index: 99999;
}
.tutorial-title-block {
  height: 30px;
  text-align: center;
  background-color: #fff;
  border-radius: 6px 6px 0 0;
  font-size: 14px;
}
.tutorial-detail-block{
  text-align: left; 
  height: 570px;
  background-color: #3e3e3e;
  border-radius: 0 0 6px 6px;
}
.tutorial-icon{
  padding-left: 80px;
  padding-right: 40px;
}
.scrollItem {
  position: relative;
  width: 290px;
  height: 400px;
  display: inline-block;
  padding-left: 10px;
  margin-top: 10px;
}
.ps {
  height: 400px;
  border-radius: 6px;
  border: 1px solid #707070;
  background-color: #2e2e2e;
}
.v-enter {
  opacity: 0;
}

/* 表示アニメーション後のスタイル */
.v-enter-to {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
.v-leave {
  opacity: 1;
}

/* 表示アニメーション動作中のスタイル */
.v-enter-active {
  transition: all 200ms;
}
.v-leave-active {
  transition: all 200ms;
}

.l-modal__bg {
width: 100%;
height: 100%;
background: rgba(89, 89, 89, 0.6);
position: fixed;
top: 0;
left: 0;
}

/* ==================================
// モーダル
// ==================================*/
/* レイアウト */
.l-modal {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
z-index: 99;
}

/* モーダルのサイズなど */
.p-modal {
width:1000px;
background: #fff;
border-radius: 3px;
padding: 10px 25px;
box-sizing: border-box;
position: relative;
top: 50%;
left: 50%;
-webkit-transform : translate(-50%,-50%);
transform : translate(-50%,-50%);
}

/* モーダル閉じるボタン */
.p-modal__btn--close{
font-size: 36px;
position: absolute;
top: 20px;
right: 40px;
}

.p-modal__btn--close:hover{
cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Tutorial.vue